import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AumicoCoreModule } from '@modeso/aumico-lib-core-fe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule } from 'angular-i18next';
import { AumicoSettingsConfig, AumicoSettingsConfigService } from './aumico-settings.config';
import { AccountingBasisFormComponent } from './components/accounting-basis-form/accounting-basis-form.component';
import { AccountingBasisListComponent } from './components/accounting-basis-list/accounting-basis-list.component';
import { EditSettingsTranslationsComponent } from './components/edit-settings-translations/edit-settings-translations.component';
import { FinancialLineItemFormComponent } from './components/financial-line-item-form/financial-line-item-form.component';
import { FinancialLineItemListComponent } from './components/financial-line-item-list/financial-line-item-list.component';
import { LegalFormFormComponent } from './components/legal-form-form/legal-form-form.component';
import { LegalFormListComponent } from './components/legal-form-list/legal-form-list.component';
import { FinancialLineItemFormDialog } from './dialogs/financial-line-item-form/financial-line-item-form.dialog';
import { effects } from './effects/effects';
import { AccountingBasisPage } from './pages/accounting-basis/accounting-basis.page';
import { FinancialLineItemPage } from './pages/financial-line-item/financial-line-item.page';
import { LegalFormPage } from './pages/legal-form/legal-form.page';
import { TranslationsFormFilterPipe } from './pipes/translations-form-filter.pipe';
import { reducers, settingsFeatureKey } from './reducers/settings-root.reducer';
import { AumicoSettingsService } from './services/aumico-settings.service';

const EXPORTED_DECLARATIONS = [
    AccountingBasisListComponent,
    AccountingBasisFormComponent,
    AccountingBasisPage,

    LegalFormListComponent,
    LegalFormFormComponent,
    LegalFormPage,

    FinancialLineItemListComponent,
    FinancialLineItemFormComponent,
    FinancialLineItemFormDialog,
    FinancialLineItemPage,

    EditSettingsTranslationsComponent,
    TranslationsFormFilterPipe,
];
@NgModule({
    declarations: [EXPORTED_DECLARATIONS],
    providers: [
        {
            provide: MatDialogRef,
            useValue: {},
        },
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatExpansionModule,
        MatTableModule,
        MatIconModule,
        MatFormFieldModule,
        I18NextModule,
        AumicoCoreModule,
        MatDialogModule,
        StoreModule.forFeature(settingsFeatureKey, reducers),
        EffectsModule.forFeature([...effects]),
    ],
    exports: [EXPORTED_DECLARATIONS],
})
export class AumicoLibSettingsFeModule {
    static forRoot(config: AumicoSettingsConfig): ModuleWithProviders<AumicoLibSettingsFeModule> {
        return {
            ngModule: AumicoLibSettingsFeModule,
            providers: [
                AumicoSettingsService,
                {
                    provide: AumicoSettingsConfigService,
                    useValue: config,
                },
            ],
        };
    }
}
